import DashboardLayout from './DashboardLayout';
export default function SuperAdminLayout() { return <DashboardLayout area="superadmin" />; }
